module.exports = __webpack_public_path__ + "img/8b.c79b761b.jpg";